export const roleLabels = {
  Superuser: 'Superusuario',

  Director: 'Director',
  IELDirector: 'Director',
  IELCommercialDT: 'Director',
  IELCommercialPR: 'Director',
  DirectorNoCommercial: 'Director',
  IELMarketing: 'D. Marketing',
  PostSale: 'PostVenta',
  Presidency: 'Presidencia',

  Subdirector: 'Subdirector',
  SubDirectorPRNoCommercial: 'Subdirector',
  SubDirectorDTNoCommercial: 'Subdirector',

  RegionalManager: 'D. Territorial',
  IELRegManager: 'D. Territorial',

  Manager: 'G. Célula',
  IELManager: 'G. Célula',

  IELSubManager: 'G. Estatal',
  Submanager: 'G. Estatal',

  Seller: 'Asesor',
};
